module.exports = __webpack_public_path__ + "static/media/kp.4cd9243a.svg";